module.exports = __webpack_public_path__ + "static/media/photo-1.070769d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/sussex-street-mixed-use/photo-1.jpg
// module id = 164
// module chunks = 0